/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * SquadLocker Accounts Storefront API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ApiResponse,
  ColoredStyleIdsInput,
  CreateNewStoreDtoApiResponse,
  CreateNewStoreInput,
  DeleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstagePathParameters,
  DeleteStorefrontApiV1StoresStoreIdLogoUnstageParams,
  DeleteStorefrontApiV1StoresStoreIdLogoUnstagePathParameters,
  DeleteStorefrontApiV1StoresStoreIdProductsUnstagePathParameters,
  FilterableGroupedLogoAssignmentProductListDto,
  GenerateSlugInput,
  GenerateSlugOutputResponse,
  GetProductsDtoPagedList,
  GetProductsGroupedByStyleAndLogoDto,
  GetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleIdPathParameters,
  GetStorefrontApiV1StoresStoreIdLogosPathParameters,
  GetStorefrontApiV1StoresStoreIdPathParameters,
  GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentParams,
  GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentPathParameters,
  GetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogoPathParameters,
  GetStorefrontApiV1StoresStoreIdProductsParams,
  GetStorefrontApiV1StoresStoreIdProductsPathParameters,
  GetStorefrontApiV1StoresStoreIdProductsToAddParams,
  GetStorefrontApiV1StoresStoreIdProductsToAddPathParameters,
  Int32IEnumerableResponse,
  PostStorefrontApiV1StoresStoreIdGenerateSlugPathParameters,
  PostStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAllPathParameters,
  PostStorefrontApiV1StoresStoreIdLogoOnProductsStagePathParameters,
  PostStorefrontApiV1StoresStoreIdLogoStageBody,
  PostStorefrontApiV1StoresStoreIdLogoStagePathParameters,
  PostStorefrontApiV1StoresStoreIdProductsSavePathParameters,
  PostStorefrontApiV1StoresStoreIdProductsStagePathParameters,
  PostStorefrontApiV1StoresStoreIdProductsSwapLogosPathParameters,
  ProblemDetails,
  ProductsForAddResultListOutput,
  SaveStoreInput,
  StagingLogoInput,
  StoreBuilderLogosDto,
  StoreBuilderProductStatusDetailsDto,
  StoreDetailsDto,
  StringResponse,
  SwapLogosInput,
} from '../accounts.schemas';

import { fetcher } from '../../../http';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getPostStorefrontApiV1StoresUrl = () => {
  return `/storefront/api/v1/stores`;
};

export const postStorefrontApiV1Stores = async (
  createNewStoreInput: CreateNewStoreInput,
  options?: RequestInit,
): Promise<CreateNewStoreDtoApiResponse> => {
  return fetcher<CreateNewStoreDtoApiResponse>(getPostStorefrontApiV1StoresUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createNewStoreInput),
  });
};

export const getPostStorefrontApiV1StoresMutationOptions = <TError = ApiResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postStorefrontApiV1Stores>>, TError, { data: CreateNewStoreInput }, TContext>;
  request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof postStorefrontApiV1Stores>>, TError, { data: CreateNewStoreInput }, TContext> => {
  const mutationKey = ['postStorefrontApiV1Stores'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postStorefrontApiV1Stores>>, { data: CreateNewStoreInput }> = (props) => {
    const { data } = props ?? {};

    return postStorefrontApiV1Stores(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostStorefrontApiV1StoresMutationResult = NonNullable<Awaited<ReturnType<typeof postStorefrontApiV1Stores>>>;
export type PostStorefrontApiV1StoresMutationBody = CreateNewStoreInput;
export type PostStorefrontApiV1StoresMutationError = ApiResponse;

export const usePostStorefrontApiV1Stores = <TError = ApiResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof postStorefrontApiV1Stores>>, TError, { data: CreateNewStoreInput }, TContext>;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof postStorefrontApiV1Stores>>, TError, { data: CreateNewStoreInput }, TContext> => {
  return useMutation(getPostStorefrontApiV1StoresMutationOptions(options), queryClient);
};
export const getGetStorefrontApiV1StoresStoreIdUrl = ({ storeId }: GetStorefrontApiV1StoresStoreIdPathParameters) => {
  return `/storefront/api/v1/stores/${storeId}`;
};

export const getStorefrontApiV1StoresStoreId = async (
  { storeId }: GetStorefrontApiV1StoresStoreIdPathParameters,
  options?: RequestInit,
): Promise<StoreDetailsDto> => {
  return fetcher<StoreDetailsDto>(getGetStorefrontApiV1StoresStoreIdUrl({ storeId }), {
    ...options,
    method: 'GET',
  });
};

export const getGetStorefrontApiV1StoresStoreIdQueryKey = ({ storeId }: GetStorefrontApiV1StoresStoreIdPathParameters) => {
  return [`/storefront/api/v1/stores/${storeId}`] as const;
};

export const getGetStorefrontApiV1StoresStoreIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreId>>,
  TError = ApiResponse,
>(
  { storeId }: GetStorefrontApiV1StoresStoreIdPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreId>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStorefrontApiV1StoresStoreIdQueryKey({ storeId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreId>>> = ({ signal }) =>
    getStorefrontApiV1StoresStoreId({ storeId }, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: !!storeId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStorefrontApiV1StoresStoreIdQueryResult = NonNullable<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreId>>>;
export type GetStorefrontApiV1StoresStoreIdQueryError = ApiResponse;

export function useGetStorefrontApiV1StoresStoreId<TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreId>>, TError = ApiResponse>(
  pathParams: GetStorefrontApiV1StoresStoreIdPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreId>>,
          TError,
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStorefrontApiV1StoresStoreId<TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreId>>, TError = ApiResponse>(
  pathParams: GetStorefrontApiV1StoresStoreIdPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreId>>,
          TError,
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStorefrontApiV1StoresStoreId<TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreId>>, TError = ApiResponse>(
  pathParams: GetStorefrontApiV1StoresStoreIdPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreId>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetStorefrontApiV1StoresStoreId<TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreId>>, TError = ApiResponse>(
  { storeId }: GetStorefrontApiV1StoresStoreIdPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreId>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStorefrontApiV1StoresStoreIdQueryOptions({ storeId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetStorefrontApiV1StoresStoreIdProductsUrl = (
  { storeId }: GetStorefrontApiV1StoresStoreIdProductsPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/storefront/api/v1/stores/${storeId}/products?${stringifiedParams}`
    : `/storefront/api/v1/stores/${storeId}/products`;
};

export const getStorefrontApiV1StoresStoreIdProducts = async (
  { storeId }: GetStorefrontApiV1StoresStoreIdProductsPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsParams,
  options?: RequestInit,
): Promise<GetProductsDtoPagedList> => {
  return fetcher<GetProductsDtoPagedList>(getGetStorefrontApiV1StoresStoreIdProductsUrl({ storeId }, params), {
    ...options,
    method: 'GET',
  });
};

export const getGetStorefrontApiV1StoresStoreIdProductsQueryKey = (
  { storeId }: GetStorefrontApiV1StoresStoreIdProductsPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsParams,
) => {
  return [`/storefront/api/v1/stores/${storeId}/products`, ...(params ? [params] : [])] as const;
};

export const getGetStorefrontApiV1StoresStoreIdProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProducts>>,
  TError = ApiResponse,
>(
  { storeId }: GetStorefrontApiV1StoresStoreIdProductsPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProducts>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStorefrontApiV1StoresStoreIdProductsQueryKey({ storeId }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProducts>>> = ({ signal }) =>
    getStorefrontApiV1StoresStoreIdProducts({ storeId }, params, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: !!storeId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStorefrontApiV1StoresStoreIdProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProducts>>>;
export type GetStorefrontApiV1StoresStoreIdProductsQueryError = ApiResponse;

export function useGetStorefrontApiV1StoresStoreIdProducts<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProducts>>,
  TError = ApiResponse,
>(
  pathParams: GetStorefrontApiV1StoresStoreIdProductsPathParameters,
  params: undefined | GetStorefrontApiV1StoresStoreIdProductsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProducts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProducts>>,
          TError,
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProducts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStorefrontApiV1StoresStoreIdProducts<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProducts>>,
  TError = ApiResponse,
>(
  pathParams: GetStorefrontApiV1StoresStoreIdProductsPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProducts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProducts>>,
          TError,
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProducts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStorefrontApiV1StoresStoreIdProducts<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProducts>>,
  TError = ApiResponse,
>(
  pathParams: GetStorefrontApiV1StoresStoreIdProductsPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProducts>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetStorefrontApiV1StoresStoreIdProducts<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProducts>>,
  TError = ApiResponse,
>(
  { storeId }: GetStorefrontApiV1StoresStoreIdProductsPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProducts>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStorefrontApiV1StoresStoreIdProductsQueryOptions({ storeId }, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleIdUrl = ({
  storeId,
  coloredStyleId,
}: GetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleIdPathParameters) => {
  return `/storefront/api/v1/stores/${storeId}/coloredstyle/${coloredStyleId}`;
};

export const getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId = async (
  { storeId, coloredStyleId }: GetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleIdPathParameters,
  options?: RequestInit,
): Promise<StoreBuilderProductStatusDetailsDto> => {
  return fetcher<StoreBuilderProductStatusDetailsDto>(getGetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleIdUrl({ storeId, coloredStyleId }), {
    ...options,
    method: 'GET',
  });
};

export const getGetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleIdQueryKey = ({
  storeId,
  coloredStyleId,
}: GetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleIdPathParameters) => {
  return [`/storefront/api/v1/stores/${storeId}/coloredstyle/${coloredStyleId}`] as const;
};

export const getGetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId>>,
  TError = ApiResponse,
>(
  { storeId, coloredStyleId }: GetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleIdPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleIdQueryKey({ storeId, coloredStyleId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId>>> = ({ signal }) =>
    getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId({ storeId, coloredStyleId }, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: !!(storeId && coloredStyleId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId>>
>;
export type GetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleIdQueryError = ApiResponse;

export function useGetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId>>,
  TError = ApiResponse,
>(
  pathParams: GetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleIdPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId>>,
          TError,
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId>>,
  TError = ApiResponse,
>(
  pathParams: GetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleIdPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId>>,
          TError,
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId>>,
  TError = ApiResponse,
>(
  pathParams: GetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleIdPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId>>,
  TError = ApiResponse,
>(
  { storeId, coloredStyleId }: GetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleIdPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdColoredstyleColoredStyleId>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStorefrontApiV1StoresStoreIdColoredstyleColoredStyleIdQueryOptions({ storeId, coloredStyleId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetStorefrontApiV1StoresStoreIdProductsToAddUrl = (
  { storeId }: GetStorefrontApiV1StoresStoreIdProductsToAddPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsToAddParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['brands', 'categories', 'colors', 'decorationMethods'];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/storefront/api/v1/stores/${storeId}/products-to-add?${stringifiedParams}`
    : `/storefront/api/v1/stores/${storeId}/products-to-add`;
};

export const getStorefrontApiV1StoresStoreIdProductsToAdd = async (
  { storeId }: GetStorefrontApiV1StoresStoreIdProductsToAddPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsToAddParams,
  options?: RequestInit,
): Promise<ProductsForAddResultListOutput> => {
  return fetcher<ProductsForAddResultListOutput>(getGetStorefrontApiV1StoresStoreIdProductsToAddUrl({ storeId }, params), {
    ...options,
    method: 'GET',
  });
};

export const getGetStorefrontApiV1StoresStoreIdProductsToAddQueryKey = (
  { storeId }: GetStorefrontApiV1StoresStoreIdProductsToAddPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsToAddParams,
) => {
  return [`/storefront/api/v1/stores/${storeId}/products-to-add`, ...(params ? [params] : [])] as const;
};

export const getGetStorefrontApiV1StoresStoreIdProductsToAddQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsToAdd>>,
  TError = ProblemDetails,
>(
  { storeId }: GetStorefrontApiV1StoresStoreIdProductsToAddPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsToAddParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsToAdd>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStorefrontApiV1StoresStoreIdProductsToAddQueryKey({ storeId }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsToAdd>>> = ({ signal }) =>
    getStorefrontApiV1StoresStoreIdProductsToAdd({ storeId }, params, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: !!storeId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsToAdd>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStorefrontApiV1StoresStoreIdProductsToAddQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsToAdd>>
>;
export type GetStorefrontApiV1StoresStoreIdProductsToAddQueryError = ProblemDetails;

export function useGetStorefrontApiV1StoresStoreIdProductsToAdd<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsToAdd>>,
  TError = ProblemDetails,
>(
  pathParams: GetStorefrontApiV1StoresStoreIdProductsToAddPathParameters,
  params: undefined | GetStorefrontApiV1StoresStoreIdProductsToAddParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsToAdd>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsToAdd>>,
          TError,
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsToAdd>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStorefrontApiV1StoresStoreIdProductsToAdd<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsToAdd>>,
  TError = ProblemDetails,
>(
  pathParams: GetStorefrontApiV1StoresStoreIdProductsToAddPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsToAddParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsToAdd>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsToAdd>>,
          TError,
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsToAdd>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStorefrontApiV1StoresStoreIdProductsToAdd<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsToAdd>>,
  TError = ProblemDetails,
>(
  pathParams: GetStorefrontApiV1StoresStoreIdProductsToAddPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsToAddParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsToAdd>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetStorefrontApiV1StoresStoreIdProductsToAdd<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsToAdd>>,
  TError = ProblemDetails,
>(
  { storeId }: GetStorefrontApiV1StoresStoreIdProductsToAddPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsToAddParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsToAdd>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStorefrontApiV1StoresStoreIdProductsToAddQueryOptions({ storeId }, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getPostStorefrontApiV1StoresStoreIdProductsStageUrl = ({ storeId }: PostStorefrontApiV1StoresStoreIdProductsStagePathParameters) => {
  return `/storefront/api/v1/stores/${storeId}/products/stage`;
};

export const postStorefrontApiV1StoresStoreIdProductsStage = async (
  { storeId }: PostStorefrontApiV1StoresStoreIdProductsStagePathParameters,
  coloredStyleIdsInput: ColoredStyleIdsInput,
  options?: RequestInit,
): Promise<Int32IEnumerableResponse> => {
  return fetcher<Int32IEnumerableResponse>(getPostStorefrontApiV1StoresStoreIdProductsStageUrl({ storeId }), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(coloredStyleIdsInput),
  });
};

export const getPostStorefrontApiV1StoresStoreIdProductsStageMutationOptions = <TError = ApiResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdProductsStage>>,
    TError,
    { pathParams: PostStorefrontApiV1StoresStoreIdProductsStagePathParameters; data: ColoredStyleIdsInput },
    TContext
  >;
  request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdProductsStage>>,
  TError,
  { pathParams: PostStorefrontApiV1StoresStoreIdProductsStagePathParameters; data: ColoredStyleIdsInput },
  TContext
> => {
  const mutationKey = ['postStorefrontApiV1StoresStoreIdProductsStage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdProductsStage>>,
    { pathParams: PostStorefrontApiV1StoresStoreIdProductsStagePathParameters; data: ColoredStyleIdsInput }
  > = (props) => {
    const { pathParams, data } = props ?? {};

    return postStorefrontApiV1StoresStoreIdProductsStage(pathParams, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostStorefrontApiV1StoresStoreIdProductsStageMutationResult = NonNullable<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdProductsStage>>
>;
export type PostStorefrontApiV1StoresStoreIdProductsStageMutationBody = ColoredStyleIdsInput;
export type PostStorefrontApiV1StoresStoreIdProductsStageMutationError = ApiResponse;

export const usePostStorefrontApiV1StoresStoreIdProductsStage = <TError = ApiResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdProductsStage>>,
      TError,
      { pathParams: PostStorefrontApiV1StoresStoreIdProductsStagePathParameters; data: ColoredStyleIdsInput },
      TContext
    >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdProductsStage>>,
  TError,
  { pathParams: PostStorefrontApiV1StoresStoreIdProductsStagePathParameters; data: ColoredStyleIdsInput },
  TContext
> => {
  return useMutation(getPostStorefrontApiV1StoresStoreIdProductsStageMutationOptions(options), queryClient);
};
export const getDeleteStorefrontApiV1StoresStoreIdProductsUnstageUrl = ({
  storeId,
}: DeleteStorefrontApiV1StoresStoreIdProductsUnstagePathParameters) => {
  return `/storefront/api/v1/stores/${storeId}/products/unstage`;
};

export const deleteStorefrontApiV1StoresStoreIdProductsUnstage = async (
  { storeId }: DeleteStorefrontApiV1StoresStoreIdProductsUnstagePathParameters,
  coloredStyleIdsInput: ColoredStyleIdsInput,
  options?: RequestInit,
): Promise<Int32IEnumerableResponse> => {
  return fetcher<Int32IEnumerableResponse>(getDeleteStorefrontApiV1StoresStoreIdProductsUnstageUrl({ storeId }), {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(coloredStyleIdsInput),
  });
};

export const getDeleteStorefrontApiV1StoresStoreIdProductsUnstageMutationOptions = <TError = ApiResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStorefrontApiV1StoresStoreIdProductsUnstage>>,
    TError,
    { pathParams: DeleteStorefrontApiV1StoresStoreIdProductsUnstagePathParameters; data: ColoredStyleIdsInput },
    TContext
  >;
  request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteStorefrontApiV1StoresStoreIdProductsUnstage>>,
  TError,
  { pathParams: DeleteStorefrontApiV1StoresStoreIdProductsUnstagePathParameters; data: ColoredStyleIdsInput },
  TContext
> => {
  const mutationKey = ['deleteStorefrontApiV1StoresStoreIdProductsUnstage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteStorefrontApiV1StoresStoreIdProductsUnstage>>,
    { pathParams: DeleteStorefrontApiV1StoresStoreIdProductsUnstagePathParameters; data: ColoredStyleIdsInput }
  > = (props) => {
    const { pathParams, data } = props ?? {};

    return deleteStorefrontApiV1StoresStoreIdProductsUnstage(pathParams, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteStorefrontApiV1StoresStoreIdProductsUnstageMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteStorefrontApiV1StoresStoreIdProductsUnstage>>
>;
export type DeleteStorefrontApiV1StoresStoreIdProductsUnstageMutationBody = ColoredStyleIdsInput;
export type DeleteStorefrontApiV1StoresStoreIdProductsUnstageMutationError = ApiResponse;

export const useDeleteStorefrontApiV1StoresStoreIdProductsUnstage = <TError = ApiResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteStorefrontApiV1StoresStoreIdProductsUnstage>>,
      TError,
      { pathParams: DeleteStorefrontApiV1StoresStoreIdProductsUnstagePathParameters; data: ColoredStyleIdsInput },
      TContext
    >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteStorefrontApiV1StoresStoreIdProductsUnstage>>,
  TError,
  { pathParams: DeleteStorefrontApiV1StoresStoreIdProductsUnstagePathParameters; data: ColoredStyleIdsInput },
  TContext
> => {
  return useMutation(getDeleteStorefrontApiV1StoresStoreIdProductsUnstageMutationOptions(options), queryClient);
};
export const getPostStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAllUrl = ({
  storeId,
}: PostStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAllPathParameters) => {
  return `/storefront/api/v1/stores/${storeId}/logo/on-products/single-stage-all`;
};

export const postStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAll = async (
  { storeId }: PostStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAllPathParameters,
  options?: RequestInit,
): Promise<Int32IEnumerableResponse> => {
  return fetcher<Int32IEnumerableResponse>(getPostStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAllUrl({ storeId }), {
    ...options,
    method: 'POST',
  });
};

export const getPostStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAllMutationOptions = <TError = ApiResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAll>>,
    TError,
    { pathParams: PostStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAllPathParameters },
    TContext
  >;
  request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAll>>,
  TError,
  { pathParams: PostStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAllPathParameters },
  TContext
> => {
  const mutationKey = ['postStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAll'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAll>>,
    { pathParams: PostStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAllPathParameters }
  > = (props) => {
    const { pathParams } = props ?? {};

    return postStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAll(pathParams, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAllMutationResult = NonNullable<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAll>>
>;

export type PostStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAllMutationError = ApiResponse;

export const usePostStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAll = <TError = ApiResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAll>>,
      TError,
      { pathParams: PostStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAllPathParameters },
      TContext
    >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAll>>,
  TError,
  { pathParams: PostStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAllPathParameters },
  TContext
> => {
  return useMutation(getPostStorefrontApiV1StoresStoreIdLogoOnProductsSingleStageAllMutationOptions(options), queryClient);
};
export const getPostStorefrontApiV1StoresStoreIdLogoOnProductsStageUrl = ({
  storeId,
}: PostStorefrontApiV1StoresStoreIdLogoOnProductsStagePathParameters) => {
  return `/storefront/api/v1/stores/${storeId}/logo/on-products/stage`;
};

export const postStorefrontApiV1StoresStoreIdLogoOnProductsStage = async (
  { storeId }: PostStorefrontApiV1StoresStoreIdLogoOnProductsStagePathParameters,
  stagingLogoInput: StagingLogoInput,
  options?: RequestInit,
): Promise<Int32IEnumerableResponse> => {
  return fetcher<Int32IEnumerableResponse>(getPostStorefrontApiV1StoresStoreIdLogoOnProductsStageUrl({ storeId }), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(stagingLogoInput),
  });
};

export const getPostStorefrontApiV1StoresStoreIdLogoOnProductsStageMutationOptions = <TError = ApiResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdLogoOnProductsStage>>,
    TError,
    { pathParams: PostStorefrontApiV1StoresStoreIdLogoOnProductsStagePathParameters; data: StagingLogoInput },
    TContext
  >;
  request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdLogoOnProductsStage>>,
  TError,
  { pathParams: PostStorefrontApiV1StoresStoreIdLogoOnProductsStagePathParameters; data: StagingLogoInput },
  TContext
> => {
  const mutationKey = ['postStorefrontApiV1StoresStoreIdLogoOnProductsStage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdLogoOnProductsStage>>,
    { pathParams: PostStorefrontApiV1StoresStoreIdLogoOnProductsStagePathParameters; data: StagingLogoInput }
  > = (props) => {
    const { pathParams, data } = props ?? {};

    return postStorefrontApiV1StoresStoreIdLogoOnProductsStage(pathParams, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostStorefrontApiV1StoresStoreIdLogoOnProductsStageMutationResult = NonNullable<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdLogoOnProductsStage>>
>;
export type PostStorefrontApiV1StoresStoreIdLogoOnProductsStageMutationBody = StagingLogoInput;
export type PostStorefrontApiV1StoresStoreIdLogoOnProductsStageMutationError = ApiResponse;

export const usePostStorefrontApiV1StoresStoreIdLogoOnProductsStage = <TError = ApiResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdLogoOnProductsStage>>,
      TError,
      { pathParams: PostStorefrontApiV1StoresStoreIdLogoOnProductsStagePathParameters; data: StagingLogoInput },
      TContext
    >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdLogoOnProductsStage>>,
  TError,
  { pathParams: PostStorefrontApiV1StoresStoreIdLogoOnProductsStagePathParameters; data: StagingLogoInput },
  TContext
> => {
  return useMutation(getPostStorefrontApiV1StoresStoreIdLogoOnProductsStageMutationOptions(options), queryClient);
};
export const getDeleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstageUrl = ({
  storeId,
}: DeleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstagePathParameters) => {
  return `/storefront/api/v1/stores/${storeId}/logo/on-products/unstage`;
};

export const deleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstage = async (
  { storeId }: DeleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstagePathParameters,
  stagingLogoInput: StagingLogoInput,
  options?: RequestInit,
): Promise<Int32IEnumerableResponse> => {
  return fetcher<Int32IEnumerableResponse>(getDeleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstageUrl({ storeId }), {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(stagingLogoInput),
  });
};

export const getDeleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstageMutationOptions = <TError = ApiResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstage>>,
    TError,
    { pathParams: DeleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstagePathParameters; data: StagingLogoInput },
    TContext
  >;
  request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstage>>,
  TError,
  { pathParams: DeleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstagePathParameters; data: StagingLogoInput },
  TContext
> => {
  const mutationKey = ['deleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstage>>,
    { pathParams: DeleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstagePathParameters; data: StagingLogoInput }
  > = (props) => {
    const { pathParams, data } = props ?? {};

    return deleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstage(pathParams, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstageMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstage>>
>;
export type DeleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstageMutationBody = StagingLogoInput;
export type DeleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstageMutationError = ApiResponse;

export const useDeleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstage = <TError = ApiResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstage>>,
      TError,
      { pathParams: DeleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstagePathParameters; data: StagingLogoInput },
      TContext
    >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstage>>,
  TError,
  { pathParams: DeleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstagePathParameters; data: StagingLogoInput },
  TContext
> => {
  return useMutation(getDeleteStorefrontApiV1StoresStoreIdLogoOnProductsUnstageMutationOptions(options), queryClient);
};
export const getPostStorefrontApiV1StoresStoreIdLogoStageUrl = ({ storeId }: PostStorefrontApiV1StoresStoreIdLogoStagePathParameters) => {
  return `/storefront/api/v1/stores/${storeId}/logo/stage`;
};

export const postStorefrontApiV1StoresStoreIdLogoStage = async (
  { storeId }: PostStorefrontApiV1StoresStoreIdLogoStagePathParameters,
  postStorefrontApiV1StoresStoreIdLogoStageBody: PostStorefrontApiV1StoresStoreIdLogoStageBody,
  options?: RequestInit,
): Promise<StringResponse> => {
  const formData = new FormData();
  if (postStorefrontApiV1StoresStoreIdLogoStageBody.file !== undefined) {
    formData.append(`file`, postStorefrontApiV1StoresStoreIdLogoStageBody.file);
  }

  return fetcher<StringResponse>(getPostStorefrontApiV1StoresStoreIdLogoStageUrl({ storeId }), {
    ...options,
    method: 'POST',
    body: formData,
  });
};

export const getPostStorefrontApiV1StoresStoreIdLogoStageMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdLogoStage>>,
    TError,
    { pathParams: PostStorefrontApiV1StoresStoreIdLogoStagePathParameters; data: PostStorefrontApiV1StoresStoreIdLogoStageBody },
    TContext
  >;
  request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdLogoStage>>,
  TError,
  { pathParams: PostStorefrontApiV1StoresStoreIdLogoStagePathParameters; data: PostStorefrontApiV1StoresStoreIdLogoStageBody },
  TContext
> => {
  const mutationKey = ['postStorefrontApiV1StoresStoreIdLogoStage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdLogoStage>>,
    { pathParams: PostStorefrontApiV1StoresStoreIdLogoStagePathParameters; data: PostStorefrontApiV1StoresStoreIdLogoStageBody }
  > = (props) => {
    const { pathParams, data } = props ?? {};

    return postStorefrontApiV1StoresStoreIdLogoStage(pathParams, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostStorefrontApiV1StoresStoreIdLogoStageMutationResult = NonNullable<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdLogoStage>>
>;
export type PostStorefrontApiV1StoresStoreIdLogoStageMutationBody = PostStorefrontApiV1StoresStoreIdLogoStageBody;
export type PostStorefrontApiV1StoresStoreIdLogoStageMutationError = unknown;

export const usePostStorefrontApiV1StoresStoreIdLogoStage = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdLogoStage>>,
      TError,
      { pathParams: PostStorefrontApiV1StoresStoreIdLogoStagePathParameters; data: PostStorefrontApiV1StoresStoreIdLogoStageBody },
      TContext
    >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdLogoStage>>,
  TError,
  { pathParams: PostStorefrontApiV1StoresStoreIdLogoStagePathParameters; data: PostStorefrontApiV1StoresStoreIdLogoStageBody },
  TContext
> => {
  return useMutation(getPostStorefrontApiV1StoresStoreIdLogoStageMutationOptions(options), queryClient);
};
export const getDeleteStorefrontApiV1StoresStoreIdLogoUnstageUrl = (
  { storeId }: DeleteStorefrontApiV1StoresStoreIdLogoUnstagePathParameters,
  params?: DeleteStorefrontApiV1StoresStoreIdLogoUnstageParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/storefront/api/v1/stores/${storeId}/logo/unstage?${stringifiedParams}`
    : `/storefront/api/v1/stores/${storeId}/logo/unstage`;
};

export const deleteStorefrontApiV1StoresStoreIdLogoUnstage = async (
  { storeId }: DeleteStorefrontApiV1StoresStoreIdLogoUnstagePathParameters,
  params?: DeleteStorefrontApiV1StoresStoreIdLogoUnstageParams,
  options?: RequestInit,
): Promise<StringResponse> => {
  return fetcher<StringResponse>(getDeleteStorefrontApiV1StoresStoreIdLogoUnstageUrl({ storeId }, params), {
    ...options,
    method: 'DELETE',
  });
};

export const getDeleteStorefrontApiV1StoresStoreIdLogoUnstageMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStorefrontApiV1StoresStoreIdLogoUnstage>>,
    TError,
    { pathParams: DeleteStorefrontApiV1StoresStoreIdLogoUnstagePathParameters; params?: DeleteStorefrontApiV1StoresStoreIdLogoUnstageParams },
    TContext
  >;
  request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteStorefrontApiV1StoresStoreIdLogoUnstage>>,
  TError,
  { pathParams: DeleteStorefrontApiV1StoresStoreIdLogoUnstagePathParameters; params?: DeleteStorefrontApiV1StoresStoreIdLogoUnstageParams },
  TContext
> => {
  const mutationKey = ['deleteStorefrontApiV1StoresStoreIdLogoUnstage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteStorefrontApiV1StoresStoreIdLogoUnstage>>,
    { pathParams: DeleteStorefrontApiV1StoresStoreIdLogoUnstagePathParameters; params?: DeleteStorefrontApiV1StoresStoreIdLogoUnstageParams }
  > = (props) => {
    const { pathParams, params } = props ?? {};

    return deleteStorefrontApiV1StoresStoreIdLogoUnstage(pathParams, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteStorefrontApiV1StoresStoreIdLogoUnstageMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteStorefrontApiV1StoresStoreIdLogoUnstage>>
>;

export type DeleteStorefrontApiV1StoresStoreIdLogoUnstageMutationError = unknown;

export const useDeleteStorefrontApiV1StoresStoreIdLogoUnstage = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteStorefrontApiV1StoresStoreIdLogoUnstage>>,
      TError,
      { pathParams: DeleteStorefrontApiV1StoresStoreIdLogoUnstagePathParameters; params?: DeleteStorefrontApiV1StoresStoreIdLogoUnstageParams },
      TContext
    >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteStorefrontApiV1StoresStoreIdLogoUnstage>>,
  TError,
  { pathParams: DeleteStorefrontApiV1StoresStoreIdLogoUnstagePathParameters; params?: DeleteStorefrontApiV1StoresStoreIdLogoUnstageParams },
  TContext
> => {
  return useMutation(getDeleteStorefrontApiV1StoresStoreIdLogoUnstageMutationOptions(options), queryClient);
};
export const getPostStorefrontApiV1StoresStoreIdProductsSaveUrl = ({ storeId }: PostStorefrontApiV1StoresStoreIdProductsSavePathParameters) => {
  return `/storefront/api/v1/stores/${storeId}/products/save`;
};

export const postStorefrontApiV1StoresStoreIdProductsSave = async (
  { storeId }: PostStorefrontApiV1StoresStoreIdProductsSavePathParameters,
  saveStoreInput: SaveStoreInput,
  options?: RequestInit,
): Promise<Int32IEnumerableResponse> => {
  return fetcher<Int32IEnumerableResponse>(getPostStorefrontApiV1StoresStoreIdProductsSaveUrl({ storeId }), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(saveStoreInput),
  });
};

export const getPostStorefrontApiV1StoresStoreIdProductsSaveMutationOptions = <TError = ApiResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdProductsSave>>,
    TError,
    { pathParams: PostStorefrontApiV1StoresStoreIdProductsSavePathParameters; data: SaveStoreInput },
    TContext
  >;
  request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdProductsSave>>,
  TError,
  { pathParams: PostStorefrontApiV1StoresStoreIdProductsSavePathParameters; data: SaveStoreInput },
  TContext
> => {
  const mutationKey = ['postStorefrontApiV1StoresStoreIdProductsSave'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdProductsSave>>,
    { pathParams: PostStorefrontApiV1StoresStoreIdProductsSavePathParameters; data: SaveStoreInput }
  > = (props) => {
    const { pathParams, data } = props ?? {};

    return postStorefrontApiV1StoresStoreIdProductsSave(pathParams, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostStorefrontApiV1StoresStoreIdProductsSaveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdProductsSave>>
>;
export type PostStorefrontApiV1StoresStoreIdProductsSaveMutationBody = SaveStoreInput;
export type PostStorefrontApiV1StoresStoreIdProductsSaveMutationError = ApiResponse;

export const usePostStorefrontApiV1StoresStoreIdProductsSave = <TError = ApiResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdProductsSave>>,
      TError,
      { pathParams: PostStorefrontApiV1StoresStoreIdProductsSavePathParameters; data: SaveStoreInput },
      TContext
    >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdProductsSave>>,
  TError,
  { pathParams: PostStorefrontApiV1StoresStoreIdProductsSavePathParameters; data: SaveStoreInput },
  TContext
> => {
  return useMutation(getPostStorefrontApiV1StoresStoreIdProductsSaveMutationOptions(options), queryClient);
};
export const getGetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentUrl = (
  { storeId }: GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['categories', 'colors', 'decorationMethods'];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/storefront/api/v1/stores/${storeId}/products/get-for-logo-assignment?${stringifiedParams}`
    : `/storefront/api/v1/stores/${storeId}/products/get-for-logo-assignment`;
};

export const getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment = async (
  { storeId }: GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentParams,
  options?: RequestInit,
): Promise<FilterableGroupedLogoAssignmentProductListDto> => {
  return fetcher<FilterableGroupedLogoAssignmentProductListDto>(
    getGetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentUrl({ storeId }, params),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentQueryKey = (
  { storeId }: GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentParams,
) => {
  return [`/storefront/api/v1/stores/${storeId}/products/get-for-logo-assignment`, ...(params ? [params] : [])] as const;
};

export const getGetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment>>,
  TError = ApiResponse,
>(
  { storeId }: GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentQueryKey({ storeId }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment>>> = ({ signal }) =>
    getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment({ storeId }, params, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: !!storeId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment>>
>;
export type GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentQueryError = ApiResponse;

export function useGetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment>>,
  TError = ApiResponse,
>(
  pathParams: GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentPathParameters,
  params: undefined | GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment>>,
          TError,
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment>>,
  TError = ApiResponse,
>(
  pathParams: GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment>>,
          TError,
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment>>,
  TError = ApiResponse,
>(
  pathParams: GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment>>,
  TError = ApiResponse,
>(
  { storeId }: GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentPathParameters,
  params?: GetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetForLogoAssignment>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStorefrontApiV1StoresStoreIdProductsGetForLogoAssignmentQueryOptions({ storeId }, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogoUrl = ({
  storeId,
}: GetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogoPathParameters) => {
  return `/storefront/api/v1/stores/${storeId}/products/get-grouped-style-and-logo`;
};

export const getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo = async (
  { storeId }: GetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogoPathParameters,
  options?: RequestInit,
): Promise<GetProductsGroupedByStyleAndLogoDto[]> => {
  return fetcher<GetProductsGroupedByStyleAndLogoDto[]>(getGetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogoUrl({ storeId }), {
    ...options,
    method: 'GET',
  });
};

export const getGetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogoQueryKey = ({
  storeId,
}: GetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogoPathParameters) => {
  return [`/storefront/api/v1/stores/${storeId}/products/get-grouped-style-and-logo`] as const;
};

export const getGetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogoQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo>>,
  TError = ApiResponse,
>(
  { storeId }: GetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogoPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogoQueryKey({ storeId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo>>> = ({ signal }) =>
    getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo({ storeId }, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: !!storeId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo>>
>;
export type GetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogoQueryError = ApiResponse;

export function useGetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo>>,
  TError = ApiResponse,
>(
  pathParams: GetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogoPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo>>,
          TError,
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo>>,
  TError = ApiResponse,
>(
  pathParams: GetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogoPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo>>,
          TError,
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo>>,
  TError = ApiResponse,
>(
  pathParams: GetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogoPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo>>,
  TError = ApiResponse,
>(
  { storeId }: GetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogoPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogo>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStorefrontApiV1StoresStoreIdProductsGetGroupedStyleAndLogoQueryOptions({ storeId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getPostStorefrontApiV1StoresStoreIdProductsSwapLogosUrl = ({
  storeId,
}: PostStorefrontApiV1StoresStoreIdProductsSwapLogosPathParameters) => {
  return `/storefront/api/v1/stores/${storeId}/products/swap-logos`;
};

export const postStorefrontApiV1StoresStoreIdProductsSwapLogos = async (
  { storeId }: PostStorefrontApiV1StoresStoreIdProductsSwapLogosPathParameters,
  swapLogosInput: SwapLogosInput,
  options?: RequestInit,
): Promise<unknown> => {
  return fetcher<unknown>(getPostStorefrontApiV1StoresStoreIdProductsSwapLogosUrl({ storeId }), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(swapLogosInput),
  });
};

export const getPostStorefrontApiV1StoresStoreIdProductsSwapLogosMutationOptions = <TError = ApiResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdProductsSwapLogos>>,
    TError,
    { pathParams: PostStorefrontApiV1StoresStoreIdProductsSwapLogosPathParameters; data: SwapLogosInput },
    TContext
  >;
  request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdProductsSwapLogos>>,
  TError,
  { pathParams: PostStorefrontApiV1StoresStoreIdProductsSwapLogosPathParameters; data: SwapLogosInput },
  TContext
> => {
  const mutationKey = ['postStorefrontApiV1StoresStoreIdProductsSwapLogos'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdProductsSwapLogos>>,
    { pathParams: PostStorefrontApiV1StoresStoreIdProductsSwapLogosPathParameters; data: SwapLogosInput }
  > = (props) => {
    const { pathParams, data } = props ?? {};

    return postStorefrontApiV1StoresStoreIdProductsSwapLogos(pathParams, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostStorefrontApiV1StoresStoreIdProductsSwapLogosMutationResult = NonNullable<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdProductsSwapLogos>>
>;
export type PostStorefrontApiV1StoresStoreIdProductsSwapLogosMutationBody = SwapLogosInput;
export type PostStorefrontApiV1StoresStoreIdProductsSwapLogosMutationError = ApiResponse;

export const usePostStorefrontApiV1StoresStoreIdProductsSwapLogos = <TError = ApiResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdProductsSwapLogos>>,
      TError,
      { pathParams: PostStorefrontApiV1StoresStoreIdProductsSwapLogosPathParameters; data: SwapLogosInput },
      TContext
    >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdProductsSwapLogos>>,
  TError,
  { pathParams: PostStorefrontApiV1StoresStoreIdProductsSwapLogosPathParameters; data: SwapLogosInput },
  TContext
> => {
  return useMutation(getPostStorefrontApiV1StoresStoreIdProductsSwapLogosMutationOptions(options), queryClient);
};
export const getGetStorefrontApiV1StoresStoreIdLogosUrl = ({ storeId }: GetStorefrontApiV1StoresStoreIdLogosPathParameters) => {
  return `/storefront/api/v1/stores/${storeId}/logos`;
};

export const getStorefrontApiV1StoresStoreIdLogos = async (
  { storeId }: GetStorefrontApiV1StoresStoreIdLogosPathParameters,
  options?: RequestInit,
): Promise<StoreBuilderLogosDto> => {
  return fetcher<StoreBuilderLogosDto>(getGetStorefrontApiV1StoresStoreIdLogosUrl({ storeId }), {
    ...options,
    method: 'GET',
  });
};

export const getGetStorefrontApiV1StoresStoreIdLogosQueryKey = ({ storeId }: GetStorefrontApiV1StoresStoreIdLogosPathParameters) => {
  return [`/storefront/api/v1/stores/${storeId}/logos`] as const;
};

export const getGetStorefrontApiV1StoresStoreIdLogosQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdLogos>>,
  TError = ApiResponse,
>(
  { storeId }: GetStorefrontApiV1StoresStoreIdLogosPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdLogos>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStorefrontApiV1StoresStoreIdLogosQueryKey({ storeId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdLogos>>> = ({ signal }) =>
    getStorefrontApiV1StoresStoreIdLogos({ storeId }, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: !!storeId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdLogos>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStorefrontApiV1StoresStoreIdLogosQueryResult = NonNullable<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdLogos>>>;
export type GetStorefrontApiV1StoresStoreIdLogosQueryError = ApiResponse;

export function useGetStorefrontApiV1StoresStoreIdLogos<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdLogos>>,
  TError = ApiResponse,
>(
  pathParams: GetStorefrontApiV1StoresStoreIdLogosPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdLogos>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdLogos>>,
          TError,
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdLogos>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStorefrontApiV1StoresStoreIdLogos<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdLogos>>,
  TError = ApiResponse,
>(
  pathParams: GetStorefrontApiV1StoresStoreIdLogosPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdLogos>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdLogos>>,
          TError,
          Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdLogos>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStorefrontApiV1StoresStoreIdLogos<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdLogos>>,
  TError = ApiResponse,
>(
  pathParams: GetStorefrontApiV1StoresStoreIdLogosPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdLogos>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetStorefrontApiV1StoresStoreIdLogos<
  TData = Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdLogos>>,
  TError = ApiResponse,
>(
  { storeId }: GetStorefrontApiV1StoresStoreIdLogosPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStorefrontApiV1StoresStoreIdLogos>>, TError, TData>>;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStorefrontApiV1StoresStoreIdLogosQueryOptions({ storeId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getPostStorefrontApiV1StoresStoreIdGenerateSlugUrl = ({ storeId }: PostStorefrontApiV1StoresStoreIdGenerateSlugPathParameters) => {
  return `/storefront/api/v1/stores/${storeId}/generate-slug`;
};

export const postStorefrontApiV1StoresStoreIdGenerateSlug = async (
  { storeId }: PostStorefrontApiV1StoresStoreIdGenerateSlugPathParameters,
  generateSlugInput: GenerateSlugInput,
  options?: RequestInit,
): Promise<GenerateSlugOutputResponse> => {
  return fetcher<GenerateSlugOutputResponse>(getPostStorefrontApiV1StoresStoreIdGenerateSlugUrl({ storeId }), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(generateSlugInput),
  });
};

export const getPostStorefrontApiV1StoresStoreIdGenerateSlugMutationOptions = <TError = ApiResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdGenerateSlug>>,
    TError,
    { pathParams: PostStorefrontApiV1StoresStoreIdGenerateSlugPathParameters; data: GenerateSlugInput },
    TContext
  >;
  request?: SecondParameter<typeof fetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdGenerateSlug>>,
  TError,
  { pathParams: PostStorefrontApiV1StoresStoreIdGenerateSlugPathParameters; data: GenerateSlugInput },
  TContext
> => {
  const mutationKey = ['postStorefrontApiV1StoresStoreIdGenerateSlug'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdGenerateSlug>>,
    { pathParams: PostStorefrontApiV1StoresStoreIdGenerateSlugPathParameters; data: GenerateSlugInput }
  > = (props) => {
    const { pathParams, data } = props ?? {};

    return postStorefrontApiV1StoresStoreIdGenerateSlug(pathParams, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostStorefrontApiV1StoresStoreIdGenerateSlugMutationResult = NonNullable<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdGenerateSlug>>
>;
export type PostStorefrontApiV1StoresStoreIdGenerateSlugMutationBody = GenerateSlugInput;
export type PostStorefrontApiV1StoresStoreIdGenerateSlugMutationError = ApiResponse;

export const usePostStorefrontApiV1StoresStoreIdGenerateSlug = <TError = ApiResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdGenerateSlug>>,
      TError,
      { pathParams: PostStorefrontApiV1StoresStoreIdGenerateSlugPathParameters; data: GenerateSlugInput },
      TContext
    >;
    request?: SecondParameter<typeof fetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postStorefrontApiV1StoresStoreIdGenerateSlug>>,
  TError,
  { pathParams: PostStorefrontApiV1StoresStoreIdGenerateSlugPathParameters; data: GenerateSlugInput },
  TContext
> => {
  return useMutation(getPostStorefrontApiV1StoresStoreIdGenerateSlugMutationOptions(options), queryClient);
};
